"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const GameConstants_1 = require("./GameConstants");
const useStyles = (0, react_jss_1.createUseStyles)({
    token: {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        borderRadius: "50%",
        position: "absolute",
        zIndex: -1,
    },
    P2: {
        backgroundColor: "var(--p2-color)",
    },
    P1: {
        backgroundColor: "var(--p1-color)",
    },
});
// pixels / s / s
const GRAVITY = 800;
const Token = ({ player, y }) => {
    const classes = useStyles();
    const tokenRef = react_1.default.createRef();
    (0, react_1.useEffect)(() => {
        if (!tokenRef.current) {
            return;
        }
        const distanceToOffset = (GameConstants_1.NUM_ROWS - y) * tokenRef.current.getBoundingClientRect().height + 10;
        tokenRef.current.animate([
            { transform: `translateY(${-distanceToOffset}px)` },
            { transform: "translateY(0)" },
        ], {
            duration: Math.sqrt((2 * distanceToOffset) / GRAVITY) * 1000,
            easing: "ease-in",
        });
    }, []);
    return (react_1.default.createElement("div", { ref: tokenRef, className: `${classes.token} ${classes[player]}` }));
};
exports.default = Token;
